import { namespace } from '../../../../../FrontendBundle/Resources/js/ofcs';
import Logger from '../../../../../FrontendBundle/Resources/js/ofcs/logger';
import OfcsObject from '../../../../../FrontendBundle/Resources/js/ofcs/object';
import ViewInterface from './itemView/viewInterface';

/**
 * Collection of view items with specific methods to operate on these items.
 */
class ViewCollection extends OfcsObject {
    views = [];
    displayBounds = false;
    displayMarginTrees = false;

    /**
     * Adds a view to the collection. The given view must assert with the ViewInterface.
     *
     * @param  {ItemView} view Item view to add.
     * @return {ViewCollection}
     */
    add(view) {
        Logger.debug('viewCollection.add()', view);

        ViewInterface.assert(view);

        this.views.push(view);

        view.on('delete', this.remove, this);

        return this;
    }

    /**
     * Returns the last inserted item view in the collection
     *
     * @return {ItemView} Last item view
     */
    last() {
        if (this.views < 1) {
            return false;
        }
        return this.views[this.views.length - 1];
    }

    /**
     * Calls each view to show its images
     *
     * @return {ViewCollection}
     */
    showImages() {
        this.views.forEach(itemView => itemView.showImage());

        return this;
    }

    /**
     * Calls each view to hide its images
     *
     * @return {ViewCollection}
     */
    hideImages() {
        this.views.forEach(itemView => itemView.hideImage());

        return this;
    }

    /**
     * Calls each view to show its bounding box
     *
     * @return {ViewCollection}
     */
    showBounds() {
        this.displayBounds = true;
        this.views.forEach(itemView => itemView.showBounds && itemView.showBounds());

        return this;
    }

    /**
     * Calls each view to hide its bounding box
     *
     * @return {ViewCollection}
     */
    hideBounds() {
        this.displayBounds = false;
        this.views.forEach(itemView => itemView.hideBounds && itemView.hideBounds());

        return this;
    }

    /**
     * Calls each view to toggle its bounding box
     *
     * @return {ViewCollection}
     */
    toggleBounds() {
        if (this.displayBounds) {
            this.hideBounds();
        } else {
            this.showBounds();
        }

        return this;
    }

    /**
     * Calls each view to show its bounding box
     *
     * @return {ViewCollection}
     */
    showMarginTrees() {
        this.displayMarginTrees = true;
        this.views.forEach(itemView => itemView.showMarginTrees && itemView.showMarginTrees());

        return this;
    }

    /**
     * Calls each view to hide its bounding box
     *
     * @return {ViewCollection}
     */
    hideMarginTrees() {
        this.displayMarginTrees = false;
        this.views.forEach(itemView => itemView.hideMarginTrees && itemView.hideMarginTrees());

        return this;
    }

    /**
     * Calls each view to toggle its bounding box
     *
     * @return {ViewCollection}
     */
    toggleMarginTrees() {
        if (this.displayMarginTrees) {
            this.hideMarginTrees();
        } else {
            this.showMarginTrees();
        }

        return this;
    }

    /**
     * Delete a view from the collection.
     *
     * @param {ItemView} view
     */
    remove(view) {
        view.off(null, null, this);

        this.views.splice(this.views.indexOf(view), 1);
    }
}

namespace('Ofcs.Editor.Canvas');
Ofcs.Editor.Canvas.ViewCollection = ViewCollection;
export default ViewCollection;
